import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["fill", "title"];
import { useTranslation } from '../../hooks/useNavConfig';
import styled, { useTheme } from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledSvg = styled.svg.withConfig({
  displayName: "ExternalLink__StyledSvg",
  componentId: "sc-1b6alkj-0"
})(["margin-left:5px !important;margin-bottom:-1px !important;width:13px;height:13px;"]);
const ExternalLinkIcon = _ref => {
  let {
      fill,
      title
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    t
  } = useTranslation();
  const theme = useTheme();
  const fillColor = fill || theme.color['icon-interactive-default'];
  return /*#__PURE__*/_jsxs(StyledSvg, Object.assign({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 27 26",
    fill: fillColor
  }, props, {
    children: [/*#__PURE__*/_jsx("title", {
      children: title || t('nav.icons.externalLink')
    }), /*#__PURE__*/_jsx("path", {
      d: "M26.9,0.9c-0.1-0.2-0.2-0.3-0.3-0.5c-0.1-0.1-0.3-0.3-0.5-0.3c0,0,0,0,0,0 C25.9,0,25.7,0,25.5,0h-9.1c-0.8,0-1.5,0.7-1.5,1.5S15.6,3,16.4,3h5.5L9.1,15.8c-0.6,0.6-0.6,1.5,0,2.1c0.3,0.3,0.7,0.4,1.1,0.4 c0.4,0,0.8-0.1,1.1-0.4L24,5.1v5.5c0,0.8,0.7,1.5,1.5,1.5c0.8,0,1.5-0.7,1.5-1.5V1.5C27,1.3,26.9,1.1,26.9,0.9 C26.9,0.9,26.9,0.9,26.9,0.9"
    }), /*#__PURE__*/_jsx("path", {
      d: "M1,22.6C1,24.5,2.5,26,4.4,26h15.2c1.9,0,3.4-1.5,3.4-3.4v-6.1c0-0.8-0.7-1.5-1.5-1.5 S20,15.7,20,16.5v6.1c0,0.2-0.2,0.4-0.4,0.4H4.4C4.2,23,4,22.8,4,22.6V7.4C4,7.2,4.2,7,4.4,7h6.1C11.3,7,12,6.3,12,5.5 C12,4.7,11.3,4,10.5,4H4.4C2.5,4,1,5.5,1,7.4V22.6z"
    })]
  }));
};
export default ExternalLinkIcon;